import { alpha, IconButton, styled } from '@mui/material';
import { keyframes } from '@emotion/react';

export const HelperIconButton = styled(IconButton)`
  background: ${({ theme }) => theme.palette.background.default};
  padding: 0;

  &:hover {
    background: ${({ theme }) => theme.palette.background.default};
  }
`;

export const IconWrapper = styled('div')`
  position: fixed;
  bottom: 10px;
  right: 10px;
  z-index: ${({ theme }) => theme.zIndex.modal};
  padding: ${({ theme }) => theme.spacing(1)};
  background: transparent;
`;

const pulseRing = keyframes`
  0%   { transform: scale(1);   opacity: 0.7; }
  100% { transform: scale(2.2); opacity: 0;   }
`;

const slideIn = keyframes`
  from { opacity: 0; transform: translateX(20px) scale(0.95); }
  to   { opacity: 1; transform: translateX(0)    scale(1);    }
`;

const slideOut = keyframes`
  from { opacity: 1; transform: translateX(0)    scale(1);    }
  to   { opacity: 0; transform: translateX(16px) scale(0.95); }
`;

export const FABWrapper = styled('div')`
  position: relative;
  display: inline-flex;
`;

export const PulseRing = styled('span')`
  position: absolute;
  inset: 0;
  border-radius: 50%;
  border: 2px solid ${({ theme }) => theme.palette.primary.main};
  animation: ${pulseRing} 1.8s ease-out 3;
  pointer-events: none;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

export const NudgeToast = styled('div')`
  position: fixed;
  bottom: 72px;
  right: 10px;
  z-index: ${({ theme }) => theme.zIndex.modal};
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1.25)};
  padding: ${({ theme }) => theme.spacing(1.25, 1.5)};
  background: ${({ theme }) => theme.palette.background.paper};
  border-radius: 14px;
  border: 1.5px solid ${({ theme }) => alpha(theme.palette.primary.main, 0.25)};
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  animation: ${slideIn} 0.35s cubic-bezier(0.34, 1.2, 0.64, 1) both;
  white-space: nowrap;

  &[data-exiting] {
    animation: ${slideOut} 0.25s ease forwards;
  }

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

export const NudgeIcon = styled('div')`
  width: 28px;
  height: 28px;
  flex-shrink: 0;
  border-radius: 50%;
  background: ${({ theme }) => alpha(theme.palette.primary.main, 0.1)};
  color: ${({ theme }) => theme.palette.primary.main};
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 15px;
  line-height: 1;
  user-select: none;
`;

export const NudgeDismiss = styled(IconButton)`
  padding: 2px;
  color: ${({ theme }) => theme.palette.text.disabled};

  &:hover {
    color: ${({ theme }) => theme.palette.text.secondary};
    background: transparent;
  }
`;
